/**
 * Build a Stripe Elements `appearance` from the live theme tokens.
 *
 * Stripe Elements render in Stripe's own iframe, so they can't inherit our
 * CSS variables — we have to read the resolved --tn-* values and hand them
 * to Stripe explicitly. Reading via getComputedStyle picks up whatever the
 * theme (or theme-studio) has set on :root at render time, so the card form
 * matches the rest of the surface instead of a hardcoded TN palette.
 */
import type { Appearance } from '@stripe/stripe-js';

export function themedStripeAppearance(): Appearance {
  const cs = getComputedStyle(document.documentElement);
  const read = (name: string, fallback: string) =>
    cs.getPropertyValue(name).trim() || fallback;
  return {
    theme: 'stripe',
    variables: {
      colorPrimary: read('--tn-color-primary', '#7C00FF'),
      colorBackground: read('--tn-color-surface', '#ffffff'),
      colorText: read('--tn-color-text', '#1a1a2e'),
      borderRadius: read('--tn-radius-md', '12px'),
      fontFamily: read('--tn-font-body', 'Inter, system-ui, sans-serif'),
    },
  };
}
